document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-grida-pdp]');
  if (!root) return;
/* ---------- Reviews — empty, with real form + photo upload ---------- */
const writeBtns = root.querySelectorAll('[data-open-review]');
const revFormWrap = root.querySelector('#revFormWrap');
const revFormClose = root.querySelector('#revFormClose');
writeBtns.forEach(b => b.addEventListener('click', (e) => {
  e.preventDefault();
  revFormWrap.classList.add('open');
  setTimeout(() => revFormWrap.scrollIntoView({ behavior: 'smooth', block: 'center' }), 80);
}));
if (revFormClose) revFormClose.addEventListener('click', (e) => { e.preventDefault(); revFormWrap.classList.remove('open'); });

const starInput = root.querySelector('#starInput');
const starValueInput = root.querySelector('#starValue');
let starValue = 0;
if (starInput) {
  const stars = starInput.querySelectorAll('span');
  function paint(litTo, hover) {
    stars.forEach((s, i) => {
      s.classList.toggle('lit', !hover && i < litTo);
      s.classList.toggle('hover-lit', hover && i < litTo);
    });
  }
  stars.forEach((s, i) => {
    s.addEventListener('mouseenter', () => { starInput.classList.add('hovering'); paint(i + 1, true); });
    s.addEventListener('click', () => { starValue = i + 1; starValueInput.value = starValue; starInput.classList.remove('hovering'); paint(starValue, false); });
  });
  starInput.addEventListener('mouseleave', () => { starInput.classList.remove('hovering'); paint(starValue, false); });
}

const photoInput = root.querySelector('#photoInput');
const photoRow = root.querySelector('#photoRow');
const photoFiles = [];
if (photoInput) {
  photoInput.addEventListener('change', (e) => {
    const files = Array.from(e.target.files || []);
    files.forEach(file => {
      if (!file.type.startsWith('image/')) return;
      if (photoFiles.length >= 6) return;
      const reader = new FileReader();
      reader.onload = (ev) => {
        photoFiles.push({ file, url: ev.target.result });
        renderPhotos();
      };
      reader.readAsDataURL(file);
    });
    photoInput.value = '';
  });
}
function renderPhotos() {
  photoRow.querySelectorAll('.rev-photo-thumb').forEach(n => n.remove());
  const upload = photoRow.querySelector('.rev-photo-upload');
  photoFiles.forEach((p, i) => {
    const wrap = document.createElement('div');
    wrap.className = 'rev-photo-thumb';
    wrap.innerHTML = '<img src="' + p.url + '" alt="Customer photo" /><button class="rm" aria-label="Remove">\u00d7</button>';
    wrap.querySelector('.rm').addEventListener('click', (e) => {
      e.preventDefault();
      photoFiles.splice(i, 1);
      renderPhotos();
    });
    photoRow.insertBefore(wrap, upload);
  });
}

const revForm = root.querySelector('#revForm');
const revSuccess = root.querySelector('#revSuccess');
if (revForm) {
  revForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const payload = {
      product: 'grida-arched-windowpane-mirror',
      rating: starValue,
      title: revForm.title.value.trim(),
      body: revForm.body.value.trim(),
      name: revForm.name.value.trim(),
      email: revForm.email.value.trim(),
      size: revForm.size.value,
      photos: photoFiles.map(p => p.file.name)
    };
    // In production: POST to /reviews via Judge.me / Shopify Product Reviews / Loox.
    // Moderation runs server-side, then the review renders here.
    console.log('[reviews] submit payload →', payload);
    revForm.style.display = 'none';
    revSuccess.classList.add('show');
  });
}


/* init */
window.GridaPdpSetSize && window.GridaPdpSetSize('medium');

});
